import { render, staticRenderFns } from "./Block3Vue.vue?vue&type=template&id=7a8d657e&scoped=true"
import script from "./Block3Vue.vue?vue&type=script&lang=js"
export * from "./Block3Vue.vue?vue&type=script&lang=js"
import style0 from "./Block3Vue.vue?vue&type=style&index=0&id=7a8d657e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d657e",
  null
  
)

export default component.exports